import { useCallback } from 'react';
import { saveUserPermissions } from 'asset-actions-lib/api/manageAccess';
export default function useSaveUserPermissions({
  objectType,
  objectId
}) {
  const saveUserPermissionsCallback = useCallback(selectedUserIds => {
    return saveUserPermissions({
      objectType,
      objectId,
      userIds: selectedUserIds
    });
  }, [objectId, objectType]);
  return {
    saveUserPermissions: saveUserPermissionsCallback
  };
}